<template>
  <div class="v2-card v2-p-8 v2-text-center">
    <h3 class="v2-heading-sm v2-mb-3">
      No Products Added
    </h3>
    <p class="v2-text-sm v2-text-muted v2-mb-6">
      Go to "Explore" and start adding some products to your Amazing Cart
    </p>
    <div class="v2-flex v2-justify-center v2-gap-3">
      <router-link
        :to="{ name: 'explore' }"
        custom
      >
        <template #default="{ navigate }">
          <V2Button
            variant="primary"
            :disabled="!isEnabledMarketplace"
            :title="!isEnabledMarketplace ? marketplaceAccessDeniedMessage : ''"
            @click="navigate"
          >
            Explore Now
          </V2Button>
        </template>
      </router-link>
      <V2Button
        variant="primary"
        @click="onImportFromExcel"
      >
        Import from Excel
      </V2Button>
    </div>
  </div>
</template>

<script>
import { marketplaceAccessDeniedMessage } from '@/constants'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'
import { mapState } from 'vuex'
import V2Button from '@/components/v2/V2Button.vue'

const { BRAND_ACCESS } = c

export default {
  name: 'V2ExploreCollection',
  components: {
    V2Button,
  },
  data() {
    return {
      marketplaceAccessDeniedMessage,
    }
  },
  computed: {
    ...mapState({
      profile: state => state.auth.profileData,
    }),
    isEnabledMarketplace() {
      return this.profile?.access?.includes(BRAND_ACCESS.MARKETPLACE)
    },
  },
  methods: {
    onImportFromExcel() {
      this.$root.$emit('bv::show::modal', 'import_from_excel_cart')
    },
  },
}
</script>
